import React, { useState, useEffect } from 'react';
import './Services.css';

const Services = () => {
 const [currentIndex, setCurrentIndex] = useState(0);
 const [isAutoPlaying, setIsAutoPlaying] = useState(true);

 const services = [
  {
   title: 'Tax Management',
   description:
    'Comprehensive tax planning, preparation, and filing services for individuals and businesses.',
   color: 'linear-gradient(135deg, #2d3748 0%, #1a202c 100%)',
   accent: '#2d3748',
  },
  {
   title: 'Accounting Services',
   description:
    'Full-service accounting including financial statement preparation and bookkeeping.',
   color: 'linear-gradient(135deg, #4a5568 0%, #2d3748 100%)',
   accent: '#4a5568',
  },
  {
   title: 'Financial Planning',
   description:
    'Strategic financial planning to help you achieve your long-term financial goals.',
   color: 'linear-gradient(135deg, #718096 0%, #4a5568 100%)',
   accent: '#718096',
  },
  {
   title: 'Bookkeeping',
   description:
    'Accurate and timely bookkeeping services to keep your financial records organized.',
   color: 'linear-gradient(135deg, #1a202c 0%, #2d3748 100%)',
   accent: '#1a202c',
  },
  {
   title: 'Business Valuations',
   description:
    'Professional business valuation services for mergers, acquisitions, and planning.',
   color: 'linear-gradient(135deg, #2d3748 0%, #4a5568 100%)',
   accent: '#2d3748',
  },
  {
   title: 'Debt & Finance Advising',
   description:
    'Expert guidance on debt management and financial structuring for your business.',
   color: 'linear-gradient(135deg, #4a5568 0%, #1a202c 100%)',
   accent: '#4a5568',
  },
 ];

 // Auto-rotate cards
 useEffect(() => {
  if (!isAutoPlaying) return;

  const interval = setInterval(() => {
   setCurrentIndex((prevIndex) => (prevIndex + 1) % services.length);
  }, 3000);

  return () => clearInterval(interval);
 }, [isAutoPlaying, services.length]);

 const nextCard = () => {
  setCurrentIndex((prevIndex) => (prevIndex + 1) % services.length);
 };

 const prevCard = () => {
  setCurrentIndex(
   (prevIndex) => (prevIndex - 1 + services.length) % services.length
  );
 };

 const goToCard = (index) => {
  setCurrentIndex(index);
 };

 return (
  <section id='services' className='section services'>
   <div className='container'>
    <div className='section-header animate-fade-in-up'>
     <h2 className='section-title'>Our Services</h2>
     <p className='section-subtitle'>
      We offer a comprehensive range of professional accounting and financial
      services tailored to meet your unique needs.
     </p>
    </div>

    <div className='floating-cards-container'>
     {services.map((service, index) => (
      <div
       key={index}
       className='floating-card'
       style={{
        '--card-color': service.accent,
        '--animation-delay': `${index * 0.1}s`,
       }}
      >
       <div className='card-body'>
        <h3 className='card-title'>{service.title}</h3>
        <p className='card-description'>{service.description}</p>
       </div>
       <div className='card-glow'></div>
      </div>
     ))}
    </div>

    <div className='services-cta animate-fade-in-up'>
     <div className='cta-content'>
      <p>If you are already our client, please log in below</p>
      <a
       href='https://vilecpa.clientportal.com'
       target='_blank'
       rel='noopener noreferrer'
       className='btn btn-primary cta-button'
      >
       Log In
      </a>
     </div>
    </div>
   </div>
  </section>
 );
};

export default Services;
